module.exports = __webpack_public_path__ + "statics/img/19.8a9ab5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/19.png
// module id = pFj6
// module chunks = 1